import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import verifyAbhaOtpApi from '@custom/rtk-apis/abha/verifyAbhaOtp';

const initialState = {
  data: {},
  status: "",
  loading: false,
  error: "",
  message: "",
};

const verifyAbhaOtpSlice = createSlice({
    name: 'Verify Abha OTP',
    initialState,
    reducers: {
      clearState: state => {
        state.data = {};
        state.status = '';
        state.loading = false;
        state.error = '';
        state.message = '';
      },
    },
    extraReducers: (builder) => {
      builder
        .addCase(verifyAbhaOtpApi.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(verifyAbhaOtpApi.fulfilled, (state, action: PayloadAction<any>) => {
          state.loading = false;
          state.status = action.payload.status;
          state.data = action.payload.data;
          state.message = action.payload.data.message;
        })
        .addCase(verifyAbhaOtpApi.rejected, (state, action: PayloadAction<any>) => {
          console.log("state.error", action.payload)
          state.loading = false;
          state.status = "FAILED";
          state.error = action.payload;
        });
    },
  });
  
export default verifyAbhaOtpSlice.reducer;
export const { clearState } = verifyAbhaOtpSlice.actions;
